import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getPieceDropdown = createAsyncThunk(
    '/user/get-piece-dropdown',
    async (payload) => {
        try {
            const myurl = `${V_URL}/prosafe/get-dropdown-pieces`;
            const response = await axios({
                method: 'post',
                url: myurl,
                data: payload,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const piece = response.data;

            if (piece.success === true) {
                return piece;
            } else {
                throw new Error(piece);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const getPieceDropdownSlice = createSlice({
    name: "getPieceDropdown",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPieceDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getPieceDropdown.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getPieceDropdown.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getPieceDropdownSlice.reducer;